import { BetPlacementError } from '../bet-placement-error';

export class BetPlacementExtensionError extends BetPlacementError {}
